const AnalyticsConstants = {
  EventNames: {
    DesignAddProduct: 'design add product',
    DesignCopyStyle: 'design copy style',
    DesignDuplicate: 'design duplicate',
    DesignItemConfigUpdate: 'design item config update',
    DesignRemoveProduct: 'design remove product',
    DesignSave: 'design save',
    DesignShopProducts: 'design shop products',
    DesignSwapProducts: 'design swap products',
    InstallationSummaryModal: 'installation summary modal',
    CartAdd: 'cart add',
  },
  PageNames: {
    CustomBlindsDIYEstimatesPLP: 'custom blinds>diy estimates>plp',
    DesignSummary: 'interconnected quotes>design summary',
    IQCustomBlindsPLP: 'interconnected quotes>custom blinds>diy estimates>plp',
    IQMyEstimates: 'interconnected quotes>my estimates',
    MyAccountMyEstimates: 'my account>my estimates',
    MyEstimates: 'my estimates',
  },
  PageTypes: {
    DIYEstimatesPLP: 'tool:diy estimates:plp',
    Estimates: 'estimates',
    IQPLP: 'tool:interconnected quotes:plp',
    InterconnectedQuotes: 'tool:interconnected quotes:content',
    MyAccount: 'my account',
  },
  PrimaryCategories: {
    InterconnectedQuotes: 'interconnected quotes',
    CustomBlinds: 'custom blinds',
    Overlay: 'overlay',
    ButtonSubmission: 'button submission',
  },
  SubCategories1: {
    CustomBlindsDIYEstimates: 'custom blinds>diy estimates',
  },
  SubCategories2: {
    CustomBlindsDIYEstimatesPLP: 'custom blinds>diy estimates>plp',
  },
};

export default AnalyticsConstants;
